import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { BookmarkSimple } from "@phosphor-icons/react/BookmarkSimple";
import { Copy } from "@phosphor-icons/react/Copy";
import { NotePencil } from "@phosphor-icons/react/NotePencil";
import { PlusSquare } from "@phosphor-icons/react/PlusSquare";
import { Share } from "@phosphor-icons/react/Share";
import { Textbox } from "@phosphor-icons/react/Textbox";
import { TrashSimple as TrashIcon } from "@phosphor-icons/react/TrashSimple";
import { UsersFour } from "@phosphor-icons/react/UsersFour";

export interface ItemMenuProps {
	anchorEl: HTMLElement | null;
	onClose: () => void;
	onDelete: () => void;
	open: boolean;
	onShare: () => void;
	onEditAttributes: () => void;
	onEditGeometry: () => void;
	onCreateFeature: () => void;
}

export function ItemMenu({
	anchorEl,
	onClose,
	onDelete,
	onShare,
	onEditAttributes,
	onEditGeometry,
	onCreateFeature,
	open = false,
}: ItemMenuProps) {
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			transformOrigin={{ horizontal: "left", vertical: "top" }}>
			<MenuItem>
				<ListItemIcon>
					<Copy />
				</ListItemIcon>
				Copy Link
			</MenuItem>
			<MenuItem onClick={onShare}>
				<ListItemIcon>
					<Share />
				</ListItemIcon>
				Share
			</MenuItem>
			<MenuItem>
				<ListItemIcon>
					<BookmarkSimple />
				</ListItemIcon>
				Bookmark
			</MenuItem>
			<Divider />
			<MenuItem onClick={onEditAttributes}>
				<ListItemIcon>
					<Textbox />
				</ListItemIcon>
				Edit Attributes
			</MenuItem>
			<MenuItem onClick={onEditGeometry}>
				<ListItemIcon>
					<NotePencil />
				</ListItemIcon>
				Edit Geometry
			</MenuItem>
			<MenuItem>
				<ListItemIcon>
					<UsersFour />
				</ListItemIcon>
				Edit data access
			</MenuItem>
			<Divider />
			<MenuItem onClick={onCreateFeature}>
				<ListItemIcon>
					<PlusSquare />
				</ListItemIcon>
				Add feature
			</MenuItem>
			<MenuItem
				onClick={onDelete}
				sx={{ color: "var(--mui-palette-error-main)" }}>
				<ListItemIcon>
					<TrashIcon />
				</ListItemIcon>
				Delete feature
			</MenuItem>
		</Menu>
	);
}
